export default {
  title: {
    id: 'bo_sellers-orders-drawers-contact_customer-modal_title',
    defaultMessage: 'Contact customer',
  },
  prompt: {
    id: 'bo_sellers-orders-drawers-contact_customer-info_message',
    defaultMessage: 'Write a message to your customer',
  },
  message: {
    id: 'bo_sellers-orders-drawers-contact_customer-message_to_customer',
    defaultMessage: 'Your message',
  },
  confirm: {
    id: 'bo_sellers-orders-drawers-contact_customer-send_message',
    defaultMessage: 'Send message',
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-contact_customer-keep_order',
    defaultMessage: 'No, keep this order',
  },
  successMessage: {
    id: 'bo_sellers-orders-drawers-contact_customer-message_sent',
    defaultMessage: 'Message sent!',
  },
  required: {
    id: 'bo_sellers-orders-drawers-contact_customer-required',
    defaultMessage: 'This field is required',
  },
  orderLines: {
    id: 'bo_sellers-orders-drawers-contact_customer-order_lines',
    defaultMessage: 'Order lines',
  },
  selectOrderLines: {
    id: 'bo_sellers-orders-drawers-contact_customer-select_order_lines',
    defaultMessage: 'Select an order line',
  },
  subtitle: {
    id: 'bo_seller.orders.drawers.contact_customer.subtitle',
    defaultMessage: 'Next step: Send a message to your customer.',
  },
  infoText: {
    id: 'bo_seller.orders.drawers.contact_customer.info_text',
    defaultMessage:
      'Share updates, clarify any issues, or share important information about their order.',
  },
} as const
